var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08805 11L6.57152 9.72153C6.20946 8.82541 6.64241 7.80546 7.53853 7.4434L23.7643 0.887779C24.6603 0.525722 25.6804 0.958672 26.0423 1.85479L35.8757 26.1933C36.2378 27.0895 35.8049 28.1094 34.9089 28.4715L18.683 35.0272C17.787 35.3892 16.7669 34.9563 16.4049 34.0601L16.2503 33.6776V33.75H9.25037C8.28386 33.75 7.50037 32.9665 7.50037 32V31.528L1.63848 29.1598C0.742355 28.7977 0.309406 27.7778 0.671463 26.8816L7.08805 11ZM11.0004 30.25H14.8656L11.0004 20.6833V30.25ZM7.50037 19.3227L4.57218 26.5701L7.50037 27.8147V19.3227ZM10.4722 10.033L18.9945 31.1264L31.9751 25.8818L23.4528 4.78848L10.4722 10.033ZM15.684 13.5896C14.7879 13.9516 13.768 13.5187 13.4059 12.6226C13.0439 11.7264 13.4768 10.7065 14.3729 10.3444C15.2691 9.98237 16.289 10.4153 16.6511 11.3114C17.0132 12.2075 16.5802 13.2275 15.684 13.5896Z",
    fill: "#0AC79A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUi);
export default __webpack_public_path__ + "static/media/ui.fb6898faf0b78d39a56702ac992d39a5.svg";
export { ForwardRef as ReactComponent };